import { render } from "./EditClient.vue?vue&type=template&id=7e05a2ec&scoped=true"
import script from "./EditClient.vue?vue&type=script&lang=js"
export * from "./EditClient.vue?vue&type=script&lang=js"

import "./EditClient.vue?vue&type=style&index=0&id=7e05a2ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e05a2ec"]])

export default __exports__